<template>
  <BannerBlock titleClass="text-danger">
    <template
      v-slot:title
      v-if="shopInfo.remainingDays > 0"
    >{{$t("banner.trial.dayLeft", { days: $tc("banner.trial.day", shopInfo.remainingDays, { count: shopInfo.remainingDays }) })}}</template>
    <template v-slot:title v-else>{{$t("banner.trial.ended")}}</template>
    <template v-slot:message>
      <!-- <template v-if="shopInfo.remainingDays > 0">{{$t("banner.trial.forOnly")}}</template> -->
      <template v-if="shopInfo.remainingDays > 0">{{$t("banner.trial.upgradeToday")}}</template>
      <template v-else>
        <template v-if="chooseFirst">{{$t("banner.trial.remain")}}</template>
        <template v-else>{{$t("banner.trial.easy2u")}}</template>
      </template>
    </template>
    <template v-slot:actions>
      <button
        class="btn btn-warning"
        @click="$router.push({ name: 'Pricing' })"
      >{{$t("generals.upgrade")}} {{$t("generals.now")}}</button>
      <button
        class="btn btn-g-info"
        :data-tooltips="$t('generals.inBeta')"
        data-position="top"
        @click="$chatbox.show"
      >{{$t("generals.liveC")}}</button>
    </template>
    <template v-slot:default v-if="shopInfo.remainingDays > 0">
      <!-- <div class="bg ml-auto col-sm-4 d-none d-sm-unset"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Trial/trial0.svg')" />
      </div>
    </template>
    <template v-slot:default v-else>
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <template v-if="chooseFirst">
          <!-- <div class="bg1 ml-auto"></div> -->
          <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Trial/trial1.svg')" />
        </template>
        <template v-else>
          <!-- <div class="bg2 ml-auto"></div> -->
          <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Trial/trial2.svg')" />
        </template>
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../BannerBlock";
export default {
  name: "TrialBlock",
  components: {
    BannerBlock
  },
  props: {
    shopInfo: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {
    svgSelect() {
      let num = Math.round(Math.random() * 10)%2;
      return num;
    },
    chooseFirst() {
      return this.svgSelect == 1 || true;
    }
  }
};
</script>

<style lang="scss" scoped>
// .bg {
//   background-image: url(~@/core/assets/Dashboard/Banner/Trial/trial0.svg);
//   width: 288px;
// }
// .bg1 {
//   background-image: url(~@/core/assets/Dashboard/Banner/Trial/trial1.svg);
//   width: 288px;
//   background-repeat: no-repeat;
// }
// .bg2 {
//   background-image: url(~@/core/assets/Dashboard/Banner/Trial/trial2.svg);
//   width: 288px;
//   background-repeat: no-repeat;
// }
</style>
